module.exports = __webpack_public_path__ + "img/14.dc7a5334.png";